module.exports = __webpack_public_path__ + "img/Zea_mays.7e327304.jpg";